var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRejectedEditPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRejectedEditPhoto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.0934064,11.0000216 L15.3735445,7.71987961 C15.6754852,7.41793861 15.6754852,6.92839677 15.3735445,6.62649895 C15.0716039,6.32455794 14.5821058,6.32455794 14.2801651,6.62649895 L10.9999838,9.90668413 L7.71980247,6.62645576 C7.41786182,6.32451475 6.92836375,6.32451475 6.62642309,6.62645576 C6.32452564,6.92839677 6.32452564,7.41793861 6.62642309,7.71983642 L9.90660442,10.9999784 L6.62642309,14.2801636 C6.32452564,14.5821046 6.32452564,15.0716464 6.62642309,15.3735442 C6.92836375,15.6754853 7.41786182,15.6754853 7.71980247,15.3735442 L10.9999838,12.0933591 L14.2801651,15.3735442 C14.5820626,15.6754853 15.0716039,15.6754853 15.3735445,15.3735442 C15.6754852,15.0716032 15.6754852,14.5821046 15.3735445,14.2801636 L12.0934064,11.0000216 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRejectedEditPhoto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0.4 C5.14371525,0.4 0.4,5.14371525 0.4,11 C0.4,16.8562847 5.14371525,21.6 11,21.6 C16.8562847,21.6 21.6,16.8562847 21.6,11 C21.6,5.14371525 16.8562847,0.4 11,0.4 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,1.4 C16.304,1.4 20.6,5.696 20.6,11 C20.6,16.304 16.304,20.6 11,20.6 C5.696,20.6 1.4,16.304 1.4,11 C1.4,5.696 5.696,1.4 11,1.4 Z",
    id: "Path",
    fill: "#FF0400",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejectedEditPhoto);
export default __webpack_public_path__ + "static/media/icRejectedEditPhoto.f55041653d26c47a1497c80fb29e22ed.svg";
export { ForwardRef as ReactComponent };